import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "../../lib/api";
import { Roundel } from "../../components/brand/icons";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-offwhite px-5" data-testid="reset-password-page">
      <div className="w-full max-w-md border border-charcoal p-8 lg:p-10">
        <Roundel className="h-16 w-16" />
        <h1 className="h-condensed mt-6 text-3xl">Choose a new password</h1>
        {done ? (
          <div data-testid="reset-success">
            <p className="body-text mt-6 text-sm">Your password has been updated.</p>
            <Link to="/admin/login" className="link-arrow mt-6 inline-block text-xs" data-testid="reset-login-link">
              Sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="mt-6 space-y-5">
            <div>
              <label htmlFor="reset-password" className="eyebrow mb-2 block text-[0.65rem]">New password</label>
              <input id="reset-password" data-testid="reset-password-input" type="password" required minLength={8} autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border border-charcoal bg-transparent px-3 py-2.5 text-sm outline-none focus:ring-1 focus:ring-charcoal" />
            </div>
            {error && <p className="text-sm" role="alert" data-testid="reset-error">{error}</p>}
            <button type="submit" disabled={busy || !token} className="link-arrow text-xs disabled:opacity-50" data-testid="reset-submit">
              {busy ? "Saving…" : "Set password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
